import styled from 'styled-components';

export const SiteHeaderStyles = styled('header')`
  background: ${({ theme }) => theme.colors.secondary};
  height: 96px;
  box-sizing: border-box;
  position: relative;

  > .logo {    
    img {
      height: 96px;
      
      @media screen and (max-width: 699px) {
        height: 70px;
      }
    }
  }

  > .title {
    @media screen and (max-width: 699px) {
      display: none;
    }
    @media screen and (min-width: 700px) and (max-width: 1100px) {
      max-height: 99.5px;
      max-width:  220px;
    }
    @media screen and (min-width: 700px) {
      color: white;
      position: absolute;
      top: 50%;
      left: 50%;
      text-align: center;
      transform: translate(-50%, -50%);

      span {
        display: block;
        text-align: center;

        &:nth-child(1) {
          font-size: 2.5rem;
          font-weight: 900;
        }

        &:nth-child(2) {
          font-size: 1.5rem;
        }

        /* Medium screens - smaller fonts */
        @media screen and (min-width: 700px) and (max-width: 1100px) {
          &:nth-child(1) {
            font-size: 1.5rem;
          }

          &:nth-child(2) {
          font-size: 0.8rem;
          }
        }
      }
    }
  }

  > .settings {
    position: absolute;
    right: 1rem;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
  }
`;